/**
 * @package   EGI / Frontend — cart
 * @author    Padmin D. Curtis (AI Partner OS3.0) for Fabio Cherici
 * @version   1.0.0 (M-EGI-385 passo 3)
 * @date      2026-07-05
 * @purpose   Focus management alla rimozione di una riga lista (pattern §7.4
 *            M-373 generalizzato per wishlist E cart): il focus va spostato
 *            PRIMA di staccare il nodo — mai lasciare il focus su un elemento
 *            rimosso dal DOM (WCAG 2.2 §2.4.3 Focus Order, A). Destinazione:
 *            azione della riga successiva → precedente → heading di fallback.
 */

/**
 * Sposta il focus sull'azione (actionSelector) della riga adiacente a quella
 * in rimozione; se non ci sono altre righe, sul fallback (heading tabindex -1).
 */
export function focusBeforeRowRemoval(
    list: HTMLElement,
    removed: HTMLElement,
    rowSelector: string,
    actionSelector: string,
    fallback: HTMLElement | null,
): void {
    const rows = Array.from(list.querySelectorAll<HTMLElement>(rowSelector));
    const index = rows.indexOf(removed);
    const next = rows[index + 1] ?? rows[index - 1];
    const target = next?.querySelector<HTMLElement>(actionSelector) ?? fallback;
    target?.focus();
}
